module.exports = __webpack_public_path__ + "media/packs/images/search/to-e6471d5b08739e7ada8bd23aa37b988d.svg";